import type {LucideIcon} from "lucide-react";
import type {ReactNode} from "react";
import {Inbox} from "lucide-react";
import {cn} from "@/lib/utils";

type Props = {
  title: string;
  description?: string;
  icon?: LucideIcon;
  action?: ReactNode;
  className?: string;
};

export function AdminEmptyState({title, description, icon: Icon = Inbox, action, className}: Props) {
  return (
    <div className={cn("admin-empty-state", className)}>
      <div className="admin-empty-state__icon">
        <Icon className="h-6 w-6" />
      </div>
      <h3 className="admin-h3">{title}</h3>
      {description ? <p className="admin-small mt-1 max-w-sm">{description}</p> : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
